import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-int.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/signin/icon_vip.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d8b55fbe"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "registerPopUp"
};
var _hoisted_2 = {
  "class": "header"
};
var _hoisted_3 = {
  "class": "name"
};
var _hoisted_4 = {
  "class": "text"
};
var _hoisted_5 = {
  key: 0,
  "class": "suffix-type discount"
};
var _hoisted_6 = {
  key: 0,
  "class": "isTld-box"
};
var _hoisted_7 = {
  key: 0
};
var _hoisted_8 = {
  "class": "register-box"
};
var _hoisted_9 = {
  "class": "item"
};
var _hoisted_10 = {
  "class": "flex"
};
var _hoisted_11 = {
  "class": "item-name"
};
var _hoisted_12 = {
  "class": "item-option"
};
var _hoisted_13 = {
  "class": "flex"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_15 = {
  key: 0,
  "class": "item"
};
var _hoisted_16 = {
  "class": "flex"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "item-name"
  }, "任意时间戳", -1);
});
var _hoisted_18 = {
  "class": "item-option"
};
var _hoisted_19 = {
  "class": "flex"
};
var _hoisted_20 = {
  key: 1,
  "class": "item"
};
var _hoisted_21 = {
  "class": "flex"
};
var _hoisted_22 = {
  "class": "item-option"
};
var _hoisted_23 = {
  "class": "mo-input--number"
};
var _hoisted_24 = {
  key: 0,
  "class": "define-append"
};
var _hoisted_25 = {
  key: 1,
  "class": "define-append"
};
var _hoisted_26 = {
  key: 2,
  "class": "item"
};
var _hoisted_27 = {
  "class": "flex"
};
var _hoisted_28 = {
  "class": "item-option"
};
var _hoisted_29 = {
  "class": "item-name"
};
var _hoisted_30 = {
  "class": "item-life"
};
var _hoisted_31 = {
  "class": "item"
};
var _hoisted_32 = {
  "class": "flex"
};
var _hoisted_33 = {
  "class": "item-name"
};
var _hoisted_34 = {
  key: 0,
  "class": "first-year-tips free"
};
var _hoisted_35 = {
  "class": "item-option"
};
var _hoisted_36 = {
  key: 0,
  "class": "item-text"
};
var _hoisted_37 = {
  key: 1,
  "class": "original-cost"
};
var _hoisted_38 = {
  key: 2,
  "class": "item-text intro-box fsb"
};
var _hoisted_39 = {
  "class": "flex-header"
};
var _hoisted_40 = {
  key: 1
};
var _hoisted_41 = {
  key: 2,
  "class": "item-box-list"
};
var _hoisted_42 = {
  key: 0,
  "class": "number"
};
var _hoisted_43 = {
  key: 0
};
var _hoisted_44 = {
  key: 1,
  "class": "number"
};
var _hoisted_45 = {
  key: 0
};
var _hoisted_46 = {
  key: 1
};
var _hoisted_47 = {
  "class": "register-box pd0"
};
var _hoisted_48 = {
  "class": "item mbo"
};
var _hoisted_49 = {
  "class": "select-box-item"
};
var _hoisted_50 = {
  "class": "select-label"
};
var _hoisted_51 = {
  "class": "select-label"
};
var _hoisted_52 = {
  key: 0,
  "class": "right-box"
};
var _hoisted_53 = {
  key: 1,
  "class": "right-box"
};
var _hoisted_54 = {
  key: 0,
  "class": "code-error-box"
};
var _hoisted_55 = {
  "class": "item mbo"
};
var _hoisted_56 = {
  "class": "flex"
};
var _hoisted_57 = {
  "class": "item-option"
};
var _hoisted_58 = {
  "class": "gas-price"
};
var _hoisted_59 = {
  key: 1,
  "class": "free-box register-box"
};
var _hoisted_60 = {
  "class": "item"
};
var _hoisted_61 = {
  "class": "free-header flex"
};
var _hoisted_62 = {
  "class": "left item-name"
};
var _hoisted_63 = {
  "class": "item-name right"
};
var _hoisted_64 = {
  "class": "item-life"
};
var _hoisted_65 = {
  "class": "item bot-line"
};
var _hoisted_66 = {
  "class": "flex"
};
var _hoisted_67 = {
  "class": "item-name"
};
var _hoisted_68 = {
  key: 0,
  "class": "first-year-tips free"
};
var _hoisted_69 = {
  "class": "item-option"
};
var _hoisted_70 = {
  "class": "item-text"
};
var _hoisted_71 = {
  "class": "item mbo"
};
var _hoisted_72 = {
  "class": "flex"
};
var _hoisted_73 = {
  "class": "item-option"
};
var _hoisted_74 = {
  "class": "gas-price"
};
var _hoisted_75 = {
  "class": "item-buy"
};
var _hoisted_76 = {
  key: 0,
  "class": "item-price"
};
var _hoisted_77 = {
  "class": "price"
};
var _hoisted_78 = {
  "class": "item-fee"
};
var _hoisted_79 = {
  key: 1,
  "class": "item-price"
};
var _hoisted_80 = {
  "class": "price"
};
var _hoisted_81 = {
  "class": "item-fee"
};
var _hoisted_82 = {
  key: 2,
  "class": "item-price"
};
var _hoisted_83 = {
  "class": "price"
};
var _hoisted_84 = {
  "class": "item-fee"
};
var _hoisted_85 = {
  "class": "item-flex"
};
var _hoisted_86 = {
  key: 0,
  "class": "disabled-text"
};
var _hoisted_87 = {
  key: 1,
  "class": "introduce-box"
};
var _hoisted_88 = {
  "class": "introduce"
};
var _hoisted_89 = {
  "class": "title"
};
var _hoisted_90 = {
  "class": "content-tip"
};
var _hoisted_91 = {
  "class": "introduce-item"
};
var _hoisted_92 = {
  "class": "priceLine"
};
var _hoisted_93 = {
  ref: "chartRef",
  style: {
    "height": "100%",
    "width": "100%"
  },
  id: "maychar"
};
var _hoisted_94 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "line"
  }, null, -1);
});
var _hoisted_95 = {
  "class": "introduce-remind flex"
};
var _hoisted_96 = {
  "class": "left"
};
var _hoisted_97 = {
  "class": "box1"
};
var _hoisted_98 = {
  "class": "leftText"
};
var _hoisted_99 = {
  "class": "price"
};
var _hoisted_100 = {
  key: 0
};
var _hoisted_101 = {
  key: 0,
  "class": "price ml2 bor0"
};
var _hoisted_102 = {
  "class": "flex-start"
};
var _hoisted_103 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    "class": "icon"
  }, null, -1);
});
var _hoisted_104 = {
  key: 0
};
var _hoisted_105 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tooltip = _resolveComponent("el-tooltip");
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_input_number = _resolveComponent("el-input-number");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");
  var _component_el_collapse = _resolveComponent("el-collapse");
  var _component_currency_select = _resolveComponent("currency-select");
  var _component_gasNumber = _resolveComponent("gasNumber");
  var _component_numberSkeleton = _resolveComponent("numberSkeleton");
  var _component_registerLoad = _resolveComponent("registerLoad");
  var _component_email_item = _resolveComponent("email-item");
  var _component_van_popup = _resolveComponent("van-popup");
  var _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: $data.registerPop,
    "onUpdate:show": _cache[12] || (_cache[12] = function ($event) {
      return $data.registerPop = $event;
    }),
    position: $options.isMobile ? 'bottom' : 'center',
    round: "",
    "class": "dialog-pop-box",
    "show-close": false,
    "z-index": "2050",
    onClickCloseIcon: $options.handleClosesBox,
    onClickOverlay: $options.handleClosesBox
  }, {
    "default": _withCtx(function () {
      var _ctx$currencySelect, _ctx$currencySelect2, _ctx$currencySelect3;
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tooltip, {
        "class": "box-item",
        effect: "dark",
        content: $props.domain,
        disabled: $options.nameLength($options.name),
        placement: "top"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("span", _hoisted_4, _toDisplayString($props.isTld ? _ctx.$getTldDot($options.name) : $options.name), 1)];
        }),
        _: 1
      }, 8, ["content", "disabled"]), $data.priceDiscount && Number($data.priceDiscount) != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($options.getDiscount($data.priceDiscount)) + "%" + _toDisplayString(_ctx.$t("query.discount_suffix")), 1)) : _createCommentVNode("", true)]), _createElementVNode("i", {
        "class": "close-box",
        onClick: _cache[0] || (_cache[0] = function () {
          return $options.handleClosesBox && $options.handleClosesBox.apply($options, arguments);
        })
      })]), $props.isTld ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.$t('myTld.rate_tips')), 1), _createElementVNode("span", null, _toDisplayString($options.getDiscount(1 - Number($data.shareRatio))) + "%", 1), _createTextVNode(_toDisplayString(_ctx.$t('myTld.rate_tips_2')) + " ", 1)])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["content scrollbar", $options.isMobile ? 'ismobile' : ''])
      }, [_createElementVNode("div", null, [!$data.isFree ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('signin.method')), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [$data.registerPeriod == 1 || !$data.registerPeriod ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $options.handleSelect(1);
        }),
        "class": _normalizeClass($data.selTime == 1 ? 'active' : '')
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('signin.year')), 1)];
        }),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true), $data.registerPeriod == 2 || !$data.registerPeriod ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return $options.handleSelect(2);
        }),
        "class": _normalizeClass([$data.selTime == 2 ? 'active' : '', "ml20"])
      }, {
        "default": _withCtx(function () {
          return [_hoisted_14, _createTextVNode(" " + _toDisplayString(_ctx.$t('signin.buy_out')), 1)];
        }),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true)])])])]), $data.testnet == 'test' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_input, {
        "class": "random_time",
        modelValue: $data.random_time,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return $data.random_time = $event;
        }),
        placeholder: "任意时间戳",
        type: "number"
      }, null, 8, ["modelValue"])])])])])) : _createCommentVNode("", true), $data.selTime == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_input_number, {
        modelValue: $data.num,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return $data.num = $event;
        }),
        min: 1,
        onChange: $options.handleChangeYear
      }, null, 8, ["modelValue", "onChange"]), $data.num == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t('signin.m_year')), 1)) : $data.num > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t('signin.m_years')), 1)) : _createCommentVNode("", true)])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('signin.hold_for_life')), 1)])])])])), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createTextVNode(_toDisplayString(_ctx.$t('signin.expense')) + " ", 1), !$data.isFree && Number($data.firstYearFreeFlag) > 0 && $data.selTime == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('signin.first_year_free')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_35, [!$data.isDutchAuction ? (_openBlock(), _createElementBlock("div", _hoisted_36, " $" + _toDisplayString($options.getNumber($data.originalPrice)), 1)) : _createCommentVNode("", true), !$data.isDutchAuction && $data.priceDiscount && Number($data.priceDiscount) != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("p", null, "$" + _toDisplayString($options.getOriginalPrice($data.priceDiscount, $data.originalPrice)), 1)])) : $data.isDutchAuction ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("span", null, "$" + _toDisplayString($options.getNumber((parseInt(Number($data.introducePrice) * 10000) / 10000).toFixed(2))), 1), _createElementVNode("b", null, "/" + _toDisplayString(_ctx.$t('signin.premium')), 1), _createTextVNode("+"), _createElementVNode("span", null, "$" + _toDisplayString($options.getNumber($data.originalPrice)), 1)])) : _createCommentVNode("", true)])])]), _createVNode(_component_el_collapse, {
        "class": "coll-pop",
        modelValue: $data.copuonCollapse,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return $data.copuonCollapse = $event;
        })
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_collapse_item, {
            name: "99",
            "class": "item-input"
          }, {
            title: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_39, [_ctx.showInvite ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                "class": _normalizeClass([$data.nowActive == 1 ? 'active' : '', "item-btn"])
              }, _toDisplayString(_ctx.$t('ShoppingCart.invitation_code')), 3)) : _createCommentVNode("", true), _ctx.showInvite ? (_openBlock(), _createElementBlock("span", _hoisted_40, "/")) : _createCommentVNode("", true), _createElementVNode("div", {
                "class": _normalizeClass([$data.nowActive == 2 ? 'active' : '', "item-btn"])
              }, _toDisplayString(_ctx.$t('ShoppingCart.coupon')), 3), _ctx.invitationCode || $data.couponList ? (_openBlock(), _createElementBlock("div", _hoisted_41, [!_ctx.invitationCode ? (_openBlock(), _createElementBlock("span", _hoisted_42, [$options.getNumber($options.getCouponPrice()) > 0 ? (_openBlock(), _createElementBlock("b", _hoisted_43, "-")) : _createCommentVNode("", true), _createTextVNode("$" + _toDisplayString($options.getNumber($options.getCouponPrice())), 1)])) : _ctx.invitationCode && _ctx.inviteStatus == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_44, [1 - _ctx.inviteeDiscount > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_45, "(" + _toDisplayString(_ctx.$t('ShoppingCart.discount')) + _toDisplayString(((1 - _ctx.inviteeDiscount) * 100).toFixed(0)) + "%" + _toDisplayString(_ctx.$t('ShoppingCart.discount1')) + ")", 1)) : _createCommentVNode("", true), $options.getNumber($options.calculate($data.originalPrice, $data.price, 2, 's')) > 0 ? (_openBlock(), _createElementBlock("b", _hoisted_46, "-")) : _createCommentVNode("", true), _createTextVNode("$" + _toDisplayString($options.getNumber($options.calculate($data.originalPrice, $data.price, 2, 's'))), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])];
            }),
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createVNode(_component_el_select, {
                modelValue: $data.nowActive,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                  return $data.nowActive = $event;
                }),
                disabled: !_ctx.showInvite,
                ref: "select",
                onChange: $options.handleType,
                onVisibleChange: $options.visibleChange,
                onFocus: $options.focusBox,
                "class": _normalizeClass(["left-box", !_ctx.showInvite ? 'disabled-box' : '']),
                "popper-class": "select-opt",
                placeholder: "Select",
                size: "large"
              }, {
                "default": _withCtx(function () {
                  return [_createVNode(_component_el_option, {
                    label: _ctx.$t('signin.invitation_code'),
                    value: 1
                  }, {
                    "default": _withCtx(function () {
                      return [_createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('signin.invitation_code')), 1)];
                    }),
                    _: 1
                  }, 8, ["label"]), _createVNode(_component_el_option, {
                    label: _ctx.$t('signin.coupon'),
                    value: 2
                  }, {
                    "default": _withCtx(function () {
                      return [_createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('signin.coupon')), 1)];
                    }),
                    _: 1
                  }, 8, ["label"])];
                }),
                _: 1
              }, 8, ["modelValue", "disabled", "onChange", "onVisibleChange", "onFocus", "class"]), $data.nowActive == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createVNode(_component_el_input, {
                modelValue: _ctx.invitationCode,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                  return _ctx.invitationCode = $event;
                }),
                disabled: _ctx.sessInvitationCode != '',
                "class": _normalizeClass(_ctx.sessInvitationCode != '' ? 'has-value' : ''),
                placeholder: _ctx.$t('signin.tips')
              }, null, 8, ["modelValue", "disabled", "class", "placeholder"])])) : (_openBlock(), _createElementBlock("div", _hoisted_53, [_createVNode(_component_el_select, {
                modelValue: $data.couponList,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                  return $data.couponList = $event;
                }),
                "popper-class": "coupon-popper-select",
                "class": "coupon-select",
                placeholder: _ctx.$t('signin.select_coupon'),
                size: "large",
                clearable: "",
                ref: "select-card1",
                onVisibleChange: $options.visibleChange,
                onFocus: _cache[8] || (_cache[8] = function ($event) {
                  return $options.focusBox(1);
                }),
                onChange: $options.handleListSel
              }, {
                "default": _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceList, function (item) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.label,
                      value: item.id,
                      disabled: _ctx.disabledSel(item, $props.registerDomainSuffix)
                    }, null, 8, ["label", "value", "disabled"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["modelValue", "placeholder", "onVisibleChange", "onChange"])]))]), _ctx.inviteStatus == 3 && _ctx.invitationCode && $data.nowActive == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.$t('signin.code_error')), 1)) : _createCommentVNode("", true)])])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"]), $data.registerPayMethod ? (_openBlock(), _createBlock(_component_currency_select, {
        key: 3,
        registerPayMethod: $data.registerPayMethod,
        onSelectChange: $options.currencySelectChange
      }, null, 8, ["registerPayMethod", "onSelectChange"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createTextVNode(_toDisplayString(_ctx.$t('ShoppingCart.estimated_gas')) + ": ", 1), _createVNode(_component_gasNumber, {
        usdPrice: _ctx.gasPrice
      }, null, 8, ["usdPrice"])])])])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('signin.method')), 1), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('renew.hold_for_life')), 1)])])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createTextVNode(_toDisplayString(_ctx.$t('signin.expense')) + " ", 1), !$data.isFree && Number($data.firstYearFreeFlag) > 0 && $data.selTime == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.$t('signin.first_year_free')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, "$" + _toDisplayString($options.calculate(0, '', 2, 'num')), 1)])])]), _createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_createTextVNode(_toDisplayString(_ctx.$t('ShoppingCart.estimated_gas')) + ": ", 1), _createVNode(_component_gasNumber, {
        usdPrice: _ctx.gasPrice
      }, null, 8, ["usdPrice"])])])])])]))]), _createElementVNode("div", _hoisted_75, [$data.selTime == 1 && !$data.isFree ? (_openBlock(), _createElementBlock("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, _toDisplayString((_ctx$currencySelect = _ctx.currencySelect) !== null && _ctx$currencySelect !== void 0 && _ctx$currencySelect.chainId ? _ctx.$t('signin.cost') : _ctx.$t('signin.total_cost')) + ": ", 1), _createVNode(_component_numberSkeleton, {
        currencySelect: _ctx.currencySelect,
        priceOg: $data.price,
        isDutchAuction: $data.isDutchAuction,
        price: _ctx.usdtPariceNum,
        usdPrice: _ctx.usdPrice
      }, null, 8, ["currencySelect", "priceOg", "isDutchAuction", "price", "usdPrice"])])])) : $data.selTime == 2 && !$data.isFree ? (_openBlock(), _createElementBlock("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, _toDisplayString((_ctx$currencySelect2 = _ctx.currencySelect) !== null && _ctx$currencySelect2 !== void 0 && _ctx$currencySelect2.chainId ? _ctx.$t('signin.cost') : _ctx.$t('signin.total_cost')) + ": ", 1), _createVNode(_component_numberSkeleton, {
        currencySelect: _ctx.currencySelect,
        priceOg: $data.price,
        isDutchAuction: $data.isDutchAuction,
        price: _ctx.usdtPariceNum,
        usdPrice: _ctx.usdPrice
      }, null, 8, ["currencySelect", "priceOg", "isDutchAuction", "price", "usdPrice"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, _toDisplayString((_ctx$currencySelect3 = _ctx.currencySelect) !== null && _ctx$currencySelect3 !== void 0 && _ctx$currencySelect3.chainId ? _ctx.$t('signin.cost') : _ctx.$t('signin.total_cost')) + ": ", 1), _createVNode(_component_numberSkeleton, {
        currencySelect: _ctx.currencySelect,
        priceOg: $data.price,
        isDutchAuction: $data.isDutchAuction,
        price: _ctx.usdtPariceNum,
        usdPrice: _ctx.usdPrice
      }, null, 8, ["currencySelect", "priceOg", "isDutchAuction", "price", "usdPrice"])])])), _createElementVNode("div", _hoisted_85, [_ctx.disabledBtn(_ctx.balancewallect, _ctx.usePriceExpen) ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(_ctx.$t('publish.wallect_insufficient')), 1)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        loading: _ctx.registerLoading,
        "class": "svgDisnone",
        style: _normalizeStyle(_ctx.disabledBtn(_ctx.balancewallect, _ctx.usePriceExpen) ? 'margin-left:0.8rem;opacity: 0.7;' : 'margin-left:auto'),
        disabled: $options.bugDisabled($data.domainStatus) || _ctx.disabledBtn(_ctx.balancewallect, _ctx.usePriceExpen),
        color: "#000",
        onClick: $options.handleRegisterBox,
        type: "primary"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('signin.register')), 1)];
        }),
        _: 1
      }, 8, ["loading", "style", "disabled", "onClick"])]), _ctx.recaptchaVisible ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        id: "recaptcha",
        "class": _normalizeClass($options.isMobile ? 'flex-start' : 'flex-end'),
        style: {
          "margin-top": "0.8rem"
        }
      }, null, 2)) : _createCommentVNode("", true)]), _ctx.registerLoading ? (_openBlock(), _createBlock(_component_registerLoad, {
        key: 0,
        isTld: $props.isTld,
        lockingStatus: _ctx.lockingStatus,
        registerStatus: _ctx.paymentStatus,
        type: ""
      }, null, 8, ["isTld", "lockingStatus", "registerStatus"])) : _createCommentVNode("", true), $data.isDutchAuction ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.$t('signin.introduce_title')), 1), _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t('signin.introduce_content_tip')), 1)]), _createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_createElementVNode("canvas", _hoisted_93, null, 512)]), _hoisted_94, _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_createElementVNode("div", _hoisted_97, [_createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t('signin.premium_main')), 1), _createElementVNode("div", _hoisted_99, [_createVNode(_component_el_input, {
        modelValue: $data.currentPrice,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
          return $data.currentPrice = $event;
        }),
        min: 0,
        type: "number",
        onChange: $options.setCurrentPrice,
        "class": "input-box",
        placeholder: _ctx.$t('signin.premium_main_price')
      }, {
        suffix: _withCtx(function () {
          return [$data.currentPrice ? (_openBlock(), _createElementBlock("div", _hoisted_100, "USD")) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["modelValue", "onChange", "placeholder"])]), $data.currentTargetDate ? (_openBlock(), _createElementBlock("div", _hoisted_101, [_createElementVNode("span", null, _toDisplayString($options.getFormatDate($data.currentTargetDate)) + " " + _toDisplayString(_ctx.$t('signin.target_date')), 1)])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_102, [_createElementVNode("div", {
        onClick: _cache[11] || (_cache[11] = function () {
          return $options.handleVisible && $options.handleVisible.apply($options, arguments);
        }),
        "class": "item-remind"
      }, [_hoisted_103, !$data.reminderData.reminder ? (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString(_ctx.$t('signin.target_date_me')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(_ctx.$t('signin.already_set')), 1))])])])])) : _createCommentVNode("", true)], 2)), [[_directive_loading, $data.loading]]), $data.emailVisible ? (_openBlock(), _createBlock(_component_email_item, {
        key: 1,
        premiumTime: $data.premiumTime,
        bizType: "3",
        myDomain: $props.domain,
        premiumPrice: $data.currentPrice,
        onHandleClose: $options.handleClose,
        emailVisible: $data.emailVisible
      }, null, 8, ["premiumTime", "myDomain", "premiumPrice", "onHandleClose", "emailVisible"])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["show", "position", "onClickCloseIcon", "onClickOverlay"])]);
}